// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"95":"c9be6f0bddb0ebc76a53","518":"3146bd14170fb6a9da47","879":"61dd1ccdfd585fea091a"}[chunkId] + ".js";
};